import { watchAuth } from "application/auth/authSaga";
import { watchChangeEmail } from "application/changeEmail/changeEmailSaga";
import { watchCustomerMe } from "application/customer/customerSaga";
import { watchCutoff } from "application/cutoff/cutoffSaga";
import { watchDeleteAccount } from "application/deleteAccount/deleteAccountSaga";
import { watchDelivery } from "application/delivery/deliverySaga";
import { watchInvoice } from "application/invoice/invoiceSaga";
import { watchLocale } from "application/locale/localeSaga";
import { watchMenu } from "application/menu/menuSaga";
import { watchMerchandise } from "application/merchandise/merchandiseSaga";
import { watchMonAlbumPhotoArchive } from "application/monAlbumPhotoArchive/monAlbumPhotoArchiveSaga";
import { watchReorder } from "application/reorder/reorderSaga";
import { watchStorage } from "application/storage/storageSaga";
import { watchUnzipPdf } from "application/unzipPdf/unzipPdfSaga";
import { watchWidget } from "application/widget/widgetSaga";
import { watchErrors } from "common/errorSaga";
import { all } from "redux-saga/effects";

export function* indexSaga() {
  return yield all([
    watchErrors(),
    watchAuth(),
    watchChangeEmail(),
    watchDeleteAccount(),
    watchCustomerMe(),
    watchLocale(),
    watchMerchandise(),
    watchWidget(),
    watchStorage(),
    watchDelivery(),
    watchReorder(),
    watchMenu(),
    watchMonAlbumPhotoArchive(),
    watchCutoff(),
    watchInvoice(),
    watchUnzipPdf()
  ]);
}
